import React from 'react';
import { Box, Typography } from '@mui/material';
import { EdgeProps, getBezierPath } from '@xyflow/react';
import { green, red } from '../../theme/themePrimitives';

const ConditionalEdge: React.FC<EdgeProps> = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd,
    data
  }) => {
  const [edgePath] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

  return (
    <>
      {/* Edge Line */}
      <path id={id} d={edgePath} stroke="#222" strokeWidth={2} fill="none" markerEnd={markerEnd} />

      {/* Add Node Button at Edge Center */}
      <foreignObject x={((sourceX + targetX) / 2) - 20} y={((sourceY + targetY) / 2) - 10} width="60" height="40">
        <Box display="flex" px={1} borderRadius={1} bgcolor={data?.label === 'is true' ? green[400] : red[300] } justifyContent="center" alignItems="center">
          <Typography
            variant="body2"
            whiteSpace="nowrap"
            color="white"
          >
            {data?.label as string}
          </Typography>
        </Box>
      </foreignObject>
    </>
  );
};

export default ConditionalEdge;
